import { StringSchema, string } from 'yup'

const schema: StringSchema<TExperimentName> = string<TExperimentName>()
    .matches(/^[a-z]{2}\d{2}$/)
    .required()

export default schema

export function toExperimentName(name: unknown): TExperimentName {
    return schema.validateSync(name)
}
